<script setup lang="ts">
  import { ref, onMounted, onUnmounted } from 'vue'
  import { useRoute } from 'vue-router'
  import MobileMenu from './components/MobileMenu.vue'
  import Header from './components/Header.vue'
  import { useGSAPAnimations } from './composables/useGSAPAnimations'
  import CookieConsent from './components/CookieConsent.vue'

  const route = useRoute()
  const { cleanup, setupAnimations } = useGSAPAnimations()

  const isScrolled = ref(false)
  const isMobileMenuOpen = ref(false)
  const showScrollTop = ref(false)

  const handleScroll = () => {
    isScrolled.value = window.scrollY > 0
    showScrollTop.value = window.scrollY > 300
  }

  const toggleMobileMenu = () => {
    isMobileMenuOpen.value = !isMobileMenuOpen.value
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  onMounted(() => {
    window.addEventListener('scroll', handleScroll)
    setupAnimations()
  })

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)
    cleanup()
  })
</script>

<template>
  <div class="min-h-screen bg-gradient-to-b from-teal-50 to-gray-50">
    <Header :is-scrolled="isScrolled" :toggle-mobile-menu="toggleMobileMenu" class="z-10" />

    <main class="pt-16 relative">
      <img
        src="/assets/shadow-plus.svg"
        class="shadow-plus-companion absolute top-10 right-0 w-12 h-12 opacity-50"
      />
      <img
        src="/assets/shadow-plus.svg"
        class="shadow-plus-companion absolute top-20 right-96 w-12 h-12 opacity-50"
      />
      <img
        src="/assets/shadow-plus.svg"
        class="shadow-plus-companion absolute top-96 left-0 w-12 h-12 opacity-50"
      />

      <router-view v-slot="{ Component }">
        <transition name="fade" mode="out-in">
          <component :is="Component" class="relative z-10" />
        </transition>
      </router-view>

      <button
        v-show="showScrollTop"
        class="fixed bottom-8 right-8 bg-teal-600 text-white p-3 rounded-full shadow-lg hover:bg-teal-700 transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-opacity-50 z-50"
        aria-label="Volver al inicio"
        @click="scrollToTop"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 10l7-7m0 0l7 7m-7-7v18"
          />
        </svg>
      </button>

      <MobileMenu
        v-if="!route.path.match(/^\/(jobs|admin)/)"
        :is-open="isMobileMenuOpen"
        @close="isMobileMenuOpen = false"
      />
    </main>

    <CookieConsent />
  </div>
</template>

<style>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
</style>
